<template>
  <v-form class="settings elevation-2">
    <UCardHeader :header="header" />
    <div class="settings-form__footer">
      <UDialog
        :show="dialogRenameSpace"
        :actions="dialogRenameSpaceActions"
        title="Rename Space"
        data-tid="modalRenameSpace"
        @closeDialog="
          dialogRenameSpace = false;
          spaceName = '';
        "
        @updateSpace="callUpdateSpace"
      >
        <div slot="body">
          Add the new name for your space.
          <v-text-field
            v-model="spaceName"
            label="Space Name"
            class="autofocus"
            color="secondary"
          />
        </div>
      </UDialog>
      <UDialog
        :show="dialogDeleteSpace"
        :actions="dialogDeleteSpaceActions"
        title="Delete Space"
        data-tid="modalDeleteSpace"
        @closeDialog="dialogDeleteSpace = false"
        @deleteSpace="callDeleteSpace"
      >
        <div slot="body">
          Are you sure you want to delete the space
          <strong v-if="space">{{ space.name }}</strong
          >? This action cannot be undone.
        </div>
      </UDialog>
      <v-btn color="secondary" outline @click="dialogRenameSpace = true"
        >Rename Space</v-btn
      >
      <v-btn
        v-if="isOwner"
        color="red"
        outline
        @click="dialogDeleteSpace = true"
        >Delete Space</v-btn
      >
    </div>
  </v-form>
</template>

<script>
import UCardHeader from "@/components/UCardHeader";
import UDialog from "@/components/UDialog";

export default {
  components: {
    UCardHeader,
    UDialog
  },
  props: {
    space: {
      type: Object,
      required: false,
      default: Object
    },
    updateSpace: {
      type: Function,
      required: true
    },
    deleteSpace: {
      type: Function,
      required: true
    },
    isOwner: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      header: "Space",
      spaceName: "",
      dialogRenameSpace: false,
      dialogDeleteSpace: false
    };
  },
  computed: {
    dialogRenameSpaceActions() {
      return [
        {
          id: "rename-button-confirm",
          label: "Rename",
          button_color: "primary",
          action_name: "updateSpace",
          action_value1: this.spaceName
        }
      ];
    },
    dialogDeleteSpaceActions() {
      return [
        {
          id: "delete-button-confirm",
          label: "Delete",
          button_color: "primary",
          action_name: "deleteSpace"
        }
      ];
    }
  },
  methods: {
    callUpdateSpace(spaceName) {
      this.updateSpace(spaceName);
      this.dialogRenameSpace = false;
      this.spaceName = "";
    },
    callDeleteSpace() {
      this.deleteSpace();
      this.dialogDeleteSpace = false;
    }
  }
};
</script>

<style lang="scss">
.settings {
  @include card();
  margin-bottom: 20px;

  .settings-form__footer {
    .v-btn {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
</style>
